const initialState = {
  global: {
    showLargeScreenTenantDrawer: true,
    showLargeScreenResidentDrawer: false,
    showLargeScreenReservationHubDrawer: false,
  },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    // Add cases here for any actions that modify the 'app' state
    default:
      return state;
  }
}